export default __webpack_public_path__ + "static/media/Windmills X DriveU Partnership low.36847d2b.gif";